import { QuotationDetailEnums } from "src/app/enum/quotation-enums";
import { QuotationVersionModel } from "./quotation-version.model";
import { BreakdownModel } from "./breakdown-model";

export class QuotationDetailModel {
  quotationDetailId: number = 0;
  quotationId: number = 0;
  quotationVersionId: number = 0;
  quotationVersion: QuotationVersionModel | null = null;
  costCenterId: number | null = null;
  costCenterCodeName: string = ""; //Solo para informativo
  solutionCode: string = "";
  solutionName: string | null = null;
  swBreakdown: boolean = false;
  baseValue: number = QuotationDetailEnums.Subtotal;
  unitId: number | null = null;
  unitValue: number = 0;
  quantity: number = 1;
  subtotalValue: number = 0;
  days: number = 1;
  totalValue: number = 0;
  ivaRate: number = 0;
  ivaValue: number = 0;
  image1: string | null = null;
  image2: string | null = null;
  image3: string | null = null;
  image4: string | null = null;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  totalWithIva: number = 0; //Solo front
  breakdowns: Array<BreakdownModel> | null = null;
}